import React, { useEffect, useState, useContext } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import FeatherIcon from "feather-icons-react";
import Button from "./button";
import { completeProfile, updateProfile, uploadImage } from "../core/axios/endpoints";
import { UserMockImage } from "../core/path/images"; // Adjust the import according to your project structure
import { useUser } from "../core/context/user";
import { toastrError, toastrSuccess } from "../utils/alertify";
import { setState } from "../core/axios/auth";
import { useNavigate } from "react-router-dom";
import { pushToDashboard } from "../utils/constants";
import { updateToken } from "../core/axios";

const Modal = ({ isOpen, onClose, token , isCompleteProfile }) => {
  const [validationSchema, setValidationSchema] = useState({});
  const [isProfileCompletionStep, setIsProfileCompletionStep] = useState(isCompleteProfile? true : false);
  const [isLoading, setIsLoading] = useState(false);
  const [isUploadLoading, setIsUploadLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [image, setImage] = useState(null);
  const { userData,updateUser } = useUser(); // Use the user context
  const navigate = useNavigate();
  useEffect(() => {
    const modal = document.getElementById("profile-modal");
    if (isOpen) {
      modal.showModal();
    } else if (modal.open) {
      modal.close();
    }
  }, [isOpen]);

  const handleClose = () => {
    onClose();
  };

  const handleESC = (event) => {
    event.preventDefault();
    handleClose();
  }

  const schema = (isConditionTrue) => {
    const isAdmin = userData?.role === "admin";
    return Yup.object().shape({
      naam: Yup.string().required("Naam is verplicht"),
      bedrijfsnaam: isAdmin
        ? Yup.string().optional()
        : Yup.string().required("Bedrijfsnaam is verplicht"),
      telefoonnummer: isAdmin
        ? Yup.string().optional()
        : Yup.string().required("Telefoonnummer is verplicht"),
      adres: isAdmin
        ? Yup.string().optional()
        : Yup.string().required("Adres is verplicht"),
      postcode: isAdmin
        ? Yup.string()
            .optional()
            .test(
              "valid-postcode",
              "Ongeldig postcodeformaat.",
              (v) => !v || /^[1-9][0-9]{3}\s?[a-zA-Z]{2}$/.test(v),
            )
        : Yup.string()
            .required("Postcode is verplicht")
            .matches(/^[1-9][0-9]{3}\s?[a-zA-Z]{2}$/, "Ongeldig postcodeformaat."),
      plaats: isAdmin
        ? Yup.string().optional()
        : Yup.string().required("Plaats is verplicht"),
      image: Yup.string().optional(),
      wachtwoord: isConditionTrue
        ? Yup.string()
            .required("Wachtwoord is verplicht")
            .min(8, "Wachtwoord moet minimaal 8 tekens lang zijn.")
            .matches(
              /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
              "Wachtwoord moet minimaal één hoofdletter, één kleine letter, één cijfer en één speciaal teken bevatten."
            )
        : Yup.string().optional(),
      bevestigWachtwoord: isConditionTrue
        ? Yup.string().oneOf(
            [Yup.ref("wachtwoord"), null],
            "Wachtwoorden moeten overeenkomen."
          )
        : Yup.string().optional(),
    });
  };

  useEffect(() => {
    setValidationSchema(schema(isProfileCompletionStep));
  }, [isProfileCompletionStep, userData?.role]);

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  useEffect(() => {
    if (!isProfileCompletionStep && userData) {
      
      setValue("naam", userData.naam);
      setValue("bedrijfsnaam", userData.bedrijfsnaam);
      setValue("telefoonnummer", userData.telefoonnummer);
      setValue("adres", userData.adres);
      setValue("postcode", userData.postcode);
      setValue("plaats", userData.plaats);
      setImage(userData.profielFoto);
    }
  }, [isProfileCompletionStep, userData, setValue]);

  const submitForm = async (data) => {
    setIsLoading(true);
    
    try {
      if (isProfileCompletionStep) {
        const postData  = {
          naam: data.naam,
          profielFoto: image,
          bedrijfsnaam: data.bedrijfsnaam,
          telefoonnummer: data.telefoonnummer,
          adres: data.adres,
          postcode: data.postcode,
          plaats: data.plaats,
          wachtwoord: data.wachtwoord,
          token: token,
        };
       const result = await completeProfile(postData);
        toastrSuccess(result?.successMsg || "Profiel succesvol bijgewerkt.");
        setState({ accessToken: result?.accessToken, refreshToken: result?.refreshToken});
        updateUser({
          ...postData,
          applicationFee:result?.user?.applicationFee,
          tax:result?.user?.tax,
          _id:result?.user?._id,
          role:result?.user?.role
        });
        await updateToken()
        pushToDashboard(result?.user?.role,navigate);
      } else {
        const response = await updateProfile(userData?._id, { ...data, profielFoto: image });
        updateUser({ ...data, profielFoto: image });
        toastrSuccess( response?.successMsg ||"Profiel succesvol bijgewerkt.");
      }
      setIsLoading(false);
      onClose();
    } catch (err) {
      console.error("Error updating profile:", err);
      toastrError(err?.response?.data?.error || "Er is een fout opgetreden, probeer het later opnieuw.");
      setIsLoading(false);
    }
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setIsUploadLoading(true);
      uploadImage(file, token? token : null)
        .then((res) => {
          setImage(res.data.url);
        })
        .catch((err) => {
          console.error("Fout bij het uploaden van de afbeelding:", err);
        })
        .finally(() => {
          setIsUploadLoading(false);
        });
    }
  };

  const selectAndUploadFile = () => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = '.jpg, .jpeg, .png';
    input.onchange = handleImageUpload;
    input.click();
  };

  return (
    <dialog id="profile-modal" className="modal backdrop:bg-[#091E428A]" onCancel={handleESC}>
      <div className="relative col-start-1 row-start-1 max-h-[calc(100vh-5em)] w-11/12 max-w-2xl overflow-y-auto rounded-md bg-white text-ink shadow-overlay">
        <div className="modal-content">
          {!isProfileCompletionStep && (
            <button
              type="button"
              aria-label="Sluiten"
              className="absolute right-4 top-4 flex h-8 w-8 items-center justify-center rounded text-ink-subtlest hover:bg-[#091E420F]"
              onClick={handleClose}
            >
              <FeatherIcon icon="x" size={16} />
            </button>
          )}
          <h1 className="modal-title px-6 pt-6 text-xl font-medium text-ink">Persoonlijke gegevens</h1>
          <div className="flex items-center gap-4 px-6 pt-4">
            <div className="profile-pic shrink-0">
              <img className="h-16 w-16 rounded-full object-cover" src={image || UserMockImage} alt="Profile" />
            </div>
            <button
              disabled={isUploadLoading}
              type="button"
              onClick={selectAndUploadFile}
              className="upload-button inline-flex h-8 items-center gap-1.5 rounded bg-[#091E420F] px-3 text-sm font-medium text-ink hover:bg-[#091E4224] disabled:cursor-not-allowed disabled:opacity-50"
            >
              {isUploadLoading ? <FeatherIcon icon="loader" size={16} className="animate-spin" /> : <FeatherIcon icon="upload" size={16} />}
              {isUploadLoading ? 'Uploading, Please Wait....' : 'Upload een Foto'}
            </button>
          </div>
          <form className="update-profile-form !mt-0 px-6 py-4" onSubmit={handleSubmit(submitForm)}>
            <div className="grid grid-cols-1 gap-x-6 gap-y-4 md:grid-cols-2">
              <div>
                <label htmlFor="naam" className="mb-1 block text-xs font-semibold text-ink-subtlest"> Naam </label>
                <input
                  id="naam"
                  name="naam"
                  type="text"
                  className={`${errors.naam ? "is-invalid !border-[#AE2A19]" : isSubmitted && "valid"} block w-full appearance-none !rounded !border-2 !border-solid !border-line !bg-white !px-2 !py-1.5 text-sm text-ink focus:!border-brand focus:outline-none`}
                  {...register("naam")}
                />
                <div className="invalid-feedback mt-1 min-h-[16px] text-xs font-normal text-[#AE2A19]">
                  {errors.naam?.message}
                </div>
              </div>

              <div>
                <label htmlFor="bedrijfsnaam" className="mb-1 block text-xs font-semibold text-ink-subtlest">Bedrijfsnaam </label>
                <input
                  id="bedrijfsnaam"
                  name="bedrijfsnaam"
                  type="text"
                  className={`${errors.bedrijfsnaam ? "is-invalid !border-[#AE2A19]" : isSubmitted && "valid"} block w-full appearance-none !rounded !border-2 !border-solid !border-line !bg-white !px-2 !py-1.5 text-sm text-ink focus:!border-brand focus:outline-none`}
                  {...register("bedrijfsnaam")}
                />
                <div className="invalid-feedback mt-1 min-h-[16px] text-xs font-normal text-[#AE2A19]">
                  {errors.bedrijfsnaam?.message}
                </div>
              </div>
            </div>

            <div className="mt-4 grid grid-cols-1 gap-x-6 gap-y-4 md:grid-cols-2">
              <div>
                <label htmlFor="telefoonnummer" className="mb-1 block text-xs font-semibold text-ink-subtlest">Telefoon Nummer </label>
                <input
                  id="telefoonnummer"
                  name="telefoonnummer"
                  type="text"
                  className={`${errors.telefoonnummer ? "is-invalid !border-[#AE2A19]" : isSubmitted && "valid"} block w-full appearance-none !rounded !border-2 !border-solid !border-line !bg-white !px-2 !py-1.5 text-sm text-ink focus:!border-brand focus:outline-none`}
                  {...register("telefoonnummer")}
                />
                <div className="invalid-feedback mt-1 min-h-[16px] text-xs font-normal text-[#AE2A19]">
                  {errors.telefoonnummer?.message}
                </div>
              </div>

              <div>
                <label htmlFor="adres" className="mb-1 block text-xs font-semibold text-ink-subtlest">Adres </label>
                <input
                  id="adres"
                  name="adres"
                  type="text"
                  className={`${errors.adres ? "is-invalid !border-[#AE2A19]" : isSubmitted && "valid"} block w-full appearance-none !rounded !border-2 !border-solid !border-line !bg-white !px-2 !py-1.5 text-sm text-ink focus:!border-brand focus:outline-none`}
                  {...register("adres")}
                />
                <div className="invalid-feedback mt-1 min-h-[16px] text-xs font-normal text-[#AE2A19]">
                  {errors.adres?.message}
                </div>
              </div>
            </div>

            <div className="mt-4 grid grid-cols-1 gap-x-6 gap-y-4 md:grid-cols-2">
              <div>
                <label htmlFor="postcode" className="mb-1 block text-xs font-semibold text-ink-subtlest">Postcode </label>
                <input
                  id="postcode"
                  name="postcode"
                  type="text"
                  className={`${errors.postcode ? "is-invalid !border-[#AE2A19]" : isSubmitted && "valid"} block w-full appearance-none !rounded !border-2 !border-solid !border-line !bg-white !px-2 !py-1.5 text-sm text-ink focus:!border-brand focus:outline-none`}
                  {...register("postcode")}
                />
                <div className="invalid-feedback mt-1 min-h-[16px] text-xs font-normal text-[#AE2A19]">
                  {errors.postcode?.message}
                </div>
              </div>

              <div>
                <label htmlFor="plaats" className="mb-1 block text-xs font-semibold text-ink-subtlest">Plaats </label>
                <input
                  id="plaats"
                  name="plaats"
                  type="text"
                  className={`${errors.plaats ? "is-invalid !border-[#AE2A19]" : isSubmitted && "valid"} block w-full appearance-none !rounded !border-2 !border-solid !border-line !bg-white !px-2 !py-1.5 text-sm text-ink focus:!border-brand focus:outline-none`}
                  {...register("plaats")}
                />
                <div className="invalid-feedback mt-1 min-h-[16px] text-xs font-normal text-[#AE2A19]">
                  {errors.plaats?.message}
                </div>
              </div>
            </div>

            {isProfileCompletionStep && (
              <div>


                <div className="mt-4 grid grid-cols-1 gap-x-6 gap-y-4 md:grid-cols-2">
                  <div className="relative">
                    <label htmlFor="wachtwoord" className="mb-1 block text-xs font-semibold text-ink-subtlest">Wachtwoord</label>
                    <input
                      id="wachtwoord"
                      name="wachtwoord"
                      type="password"
                      className={`${errors.wachtwoord ? "is-invalid !border-[#AE2A19]" : isSubmitted && "valid"} block w-full appearance-none !rounded !border-2 !border-solid !border-line !bg-white !px-2 !py-1.5 text-sm text-ink focus:!border-brand focus:outline-none`}
                      {...register("wachtwoord")}
                    />
                    <div className="invalid-feedback mt-1 min-h-[16px] text-xs font-normal text-[#AE2A19]">
                      {errors.wachtwoord?.message}
                    </div>
                  </div>
                  <div className="relative">
                    <label htmlFor="bevestigWachtwoord" className="mb-1 block text-xs font-semibold text-ink-subtlest">Bevestig Wachtwoord</label>
                    <input
                      id="bevestigWachtwoord"
                      name="bevestigWachtwoord"
                      type="password"
                      className={`${errors.bevestigWachtwoord ? "is-invalid !border-[#AE2A19]" : isSubmitted && "valid"} block w-full appearance-none !rounded !border-2 !border-solid !border-line !bg-white !px-2 !py-1.5 text-sm text-ink focus:!border-brand focus:outline-none`}
                      {...register("bevestigWachtwoord")}
                    />
                    <div className="invalid-feedback mt-1 min-h-[16px] text-xs font-normal text-[#AE2A19]">
                      {errors.bevestigWachtwoord?.message}
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className="mt-6 flex justify-end gap-2">
              <Button btnClassNames="h-8 rounded bg-brand px-3 text-sm font-medium text-white hover:bg-brand-hover" text="Update" isLoading={isLoading} onClick={() => { handleSubmit(); setIsSubmitted(true); }} loadingText="Updaten..." />
            </div>
          </form>
        </div>
      </div>
    </dialog>
  );
};

export default Modal;
